<app-selector [data]="sequenceCoreService.sequenceList$| async" displayKey="name"
    [formControl]="ctrl" hintStyle="margin-left: -14px; margin-top: -5px" (refreshEvent)="refresh()" [loading]="sequenceCoreService.loading" [hint]="hint" [label]="label">
</app-selector>
